module.exports = __webpack_public_path__ + "img/LinkedIn.487353a.svg";